import { IArchiveFilter } from "@/features/archive/archive.types";
import { AxiosResponse } from "axios";
import { http } from "@/utils/http";
import { cleanParams } from "@/utils/cleanParams";

export const archiveService = {
  getArchive(filter: IArchiveFilter): Promise<AxiosResponse> {
    return http.get("/tasks/archived", {
      params: cleanParams(filter),
    });
  },

  archiveTask(
    task_id: string,
    payload: { reason: string }
  ): Promise<AxiosResponse> {
    return http.patch(`/tasks/${task_id}/archive`, payload);
  },

  unarchiveTask(
    task_id: string,
    payload: { reason: string }
  ): Promise<AxiosResponse> {
    return http.patch(`/tasks/${task_id}/unarchive`, payload);
  },

  deleteTask(task_id: string): Promise<AxiosResponse> {
    return http.delete(`/tasks/${task_id}/delete`);
  },
};
